import { render, staticRenderFns } from "./YourProfile.vue?vue&type=template&id=041ac582"
import script from "./YourProfile.vue?vue&type=script&lang=js"
export * from "./YourProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports